/**
 * The English dictionary, and the shape every other one is measured against.
 *
 * `Messages` is `typeof en`, so a key missing here cannot be missed there: each Russian
 * file carries `satisfies Messages[...]` and stops compiling the moment the two drift.
 * Nothing but this barrel imports every namespace, and nothing edits it after the scaffold
 * is in place — that is what keeps twelve parallel hands off one line.
 */

import { common } from './common';
import { enums } from './enums';
import { errors } from './errors';
import { ui } from './ui';
import { shell } from './shell';
import { sync } from './sync';
import { vaults } from './vaults';
import { sidebar } from './sidebar';
import { editor } from './editor';
import { inspector } from './inspector';
import { access } from './access';
import { auth } from './auth';
import { claude } from './claude';
import { transfer } from './transfer';
import { views } from './views';
import { store } from './store';
import { authRich } from './auth.rich';
import { uiRich } from './ui.rich';
import { viewsRich } from './views.rich';

export const en = {
  common,
  enums,
  errors,
  ui,
  shell,
  sync,
  vaults,
  sidebar,
  editor,
  inspector,
  access,
  auth,
  claude,
  transfer,
  views,
  store,
  authRich,
  uiRich,
  viewsRich,
};
